var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "560px",
    height: "454px",
    viewBox: "0 0 560 454",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Agency-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agency-1",
    transform: "translate(-172.000000, -1602.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 5,
    transform: "translate(172.000000, 1602.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 560,
    height: 454
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_online_wishes_dlmr",
    transform: "translate(96.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.46493,106.003225 C272.968064,45.4885518 219.421515,1.80541729 156.56945,0.0533258787 C123.341446,-0.872960437 88.3763119,10.0708826 62.9191174,48.3673574 C17.411634,116.826447 65.7156606,164.133782 99.3919503,186.613282 C115.661681,197.495508 130.321615,210.580447 142.947137,225.489102 C165.694377,252.295191 209.454873,285.605523 261.571649,233.413355 C299.345954,195.584408 298.787373,146.311969 288.46493,106.003225 Z",
    id: "Path",
    fill: "#FFCBD1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,117.193936 C369,132.90309 356.291773,157.975 340.615385,157.975 C324.938996,157.975 312.230769,132.90309 312.230769,117.193936 C312.230769,101.484784 324.938994,88.75 340.615385,88.75 C356.291775,88.75 369,101.484784 369,117.193936 Z",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.184141,159.75 C337.279676,160.970734 336.344939,165.80545 337.68793,169.351288 C339.030922,172.897126 341.8753,175.838317 343.306499,179.355585 C343.959519,181.129453 344.428295,182.954918 344.706696,184.808106 C345.52429,189.220459 346.34413,193.7104 345.714163,198.148038 C345.116557,202.35769 343.23833,206.326445 341.142904,210.120552 C337.08467,217.466595 332.14834,224.38473 326.423077,230.75",
    id: "Path",
    stroke: "#2F2E41",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.389423,163.3 C340.615385,162.160925 338.841346,162.160925 337.067308,163.3 L337.067308,157.975 L342.389423,157.975 L342.389423,163.3 Z",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.067308,161.212309 C338.741907,162.083919 340.721835,162.075571 342.389423,161.189868",
    id: "Path",
    stroke: "#2F2E41",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.4,
    cx: 352.146635,
    cy: 106.5,
    rx: 6.20913462,
    ry: 7.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,115.418936 C0,131.128089 12.7082266,156.2 28.3846154,156.2 C44.0610041,156.2 56.7692308,131.128089 56.7692308,115.418936 C56.7692308,99.7097838 44.0610056,86.975 28.3846154,86.975 C12.7082252,86.975 0,99.7097838 0,115.418936 Z",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8158593,157.975 C31.7203237,159.195734 32.6550612,164.03045 31.3120695,167.576288 C29.9690779,171.122126 27.1246998,174.063317 25.6935006,177.580585 C25.0404814,179.354453 24.5717054,181.179918 24.2933035,183.033106 C23.4757096,187.445459 22.6558697,191.9354 23.2858371,196.373038 C23.8834434,200.58269 25.7616702,204.551445 27.8570957,208.345552 C31.9153303,215.691595 36.8516598,222.60973 42.5769231,228.975",
    id: "Path",
    stroke: "#2F2E41",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6105769,157.975 C28.3846154,156.835925 30.1586538,156.835925 31.9326923,157.975 L31.9326923,152.65 L26.6105769,152.65 L26.6105769,157.975 Z",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9326923,155.887309 C30.2580933,156.758919 28.278165,156.750571 26.6105769,155.864868",
    id: "Path",
    stroke: "#2F2E41",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.4,
    cx: 16.8533654,
    cy: 102.95,
    rx: 6.20913462,
    ry: 7.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.711538,238.575071 C347.711538,254.948972 271.041212,284 176.463569,284 C81.8859257,284 14.1923077,225.128026 14.1923077,208.754125 C14.1923077,192.380224 81.8859257,224.704864 176.463569,224.704864 C271.041212,224.704864 347.711538,222.201173 347.711538,238.575071 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.711538,238.575071 C347.711538,254.948972 271.041212,284 176.463569,284 C81.8859257,284 14.1923077,225.128026 14.1923077,208.754125 C14.1923077,192.380224 81.8859257,224.704864 176.463569,224.704864 C271.041212,224.704864 347.711538,222.201173 347.711538,238.575071 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.711538,240.552094 C347.711538,256.705268 271.041212,269.8 176.463569,269.8 C81.8859257,269.8 14.1923077,227.457362 14.1923077,211.304188 C14.1923077,195.151015 81.8859257,211.304188 176.463569,211.304188 C271.041212,211.304188 347.711538,224.398924 347.711538,240.552094 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.196575,192.99409 L147.726629,214.476232 C147.726629,214.476232 130.643811,223.276146 142.655166,223.534968 C154.666521,223.79379 211.253346,223.534968 211.253346,223.534968 C211.253346,223.534968 222.197024,223.534968 204.847293,214.217416 L201.377347,191.7 L151.196575,192.99409 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.235306,223.598201 C142.963348,221.222524 147.723422,218.747152 147.723422,218.747152 L151.193536,197.063582 L201.376681,197.109785 L204.846794,218.485893 C208.892841,220.679078 211.399283,222.360432 212.865593,223.65 C215.094034,223.152384 217.529306,221.303167 204.846794,214.428554 L201.376681,191.7 L151.193536,193.006243 L147.723422,214.689813 C147.723422,214.689813 133.368162,222.154603 140.235306,223.598201 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2F2E41",
    fillRule: "nonzero",
    x: 62.0913462,
    y: 40.825,
    width: 227.076923,
    height: 156.2,
    rx: 23.01005
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1875,49.7 L260.298077,49.7 C271.343772,49.7 280.298077,58.654305 280.298077,69.7 L280.298077,166.85 L280.298077,166.85 L69.1875,166.85 L69.1875,69.7 C69.1875,58.654305 78.141805,49.7 89.1875,49.7 Z",
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    cx: 176.516827,
    cy: 45.2625,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.168269,173.95 L289.168269,188.593426 C289.168269,190.829707 288.327456,192.974473 286.830128,194.555761 C285.3328,196.137048 283.301914,197.025281 281.184375,197.025 L70.0752232,197.025 C67.9576873,197.025276 65.926805,196.137041 64.429481,194.555754 C62.9321569,192.974467 62.0913462,190.829703 62.0913462,188.593426 L62.0913462,173.95 L289.168269,173.95 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero",
    points: "232.399038 240.473822 232.399038 243.175 90.4759615 243.175 90.4759615 241.014267 90.6712489 240.473822 94.1690103 230.75 229.49704 230.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.095067,236.42711 C288.842314,237.549914 287.88802,238.734414 285.731847,239.854534 C277.994368,243.874175 262.261479,238.782633 262.261479,238.782633 C262.261479,238.782633 250.139423,236.638822 250.139423,231.011322 C250.479791,230.769159 250.834721,230.549868 251.202038,230.354793 C254.455091,228.566632 265.24116,224.154194 284.365999,230.541624 C285.774942,231.001132 287.033444,231.858027 288.001312,233.016852 C288.776298,233.959442 289.383931,235.155065 289.095067,236.42711 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.093018,236.817846 C279.357278,240.747956 270.679421,241.041224 261.773537,234.524608 C257.282147,231.239751 253.201725,230.426911 250.139423,230.488388 C253.483523,228.624505 264.571478,224.025214 284.231591,230.683132 C285.679968,231.162099 286.973693,232.05528 287.968651,233.263178 C288.765328,234.24568 289.389967,235.491934 289.093018,236.817846 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    cx: 276.75,
    cy: 231.6375,
    rx: 3.54807692,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    cx: 174.742788,
    cy: 185.4875,
    rx: 4.43509615,
    ry: 4.4375
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "232.399038 239.625 232.399038 241.4 90.4759615 241.4 90.4759615 239.980138 90.6712489 239.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.381256,104.725 C296.476792,105.945734 295.542054,110.78045 296.885046,114.326288 C298.228037,117.872126 301.072416,120.813317 302.503615,124.330585 C303.156634,126.104453 303.62541,127.929918 303.903812,129.783106 C304.721406,134.195459 305.541246,138.6854 304.911278,143.123038 C304.313672,147.33269 302.435445,151.301445 300.34002,155.095552 C296.281785,162.441595 291.345456,169.35973 285.620192,175.725",
    id: "Path",
    stroke: "#2F2E41",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.197115,62.1689356 C328.197115,77.8780895 315.488889,102.95 299.8125,102.95 C284.136111,102.95 271.427885,77.8780895 271.427885,62.1689356 C271.427885,46.4597838 284.13611,33.725 299.8125,33.725 C315.48889,33.725 328.197115,46.4597838 328.197115,62.1689356 L328.197115,62.1689356 Z",
    id: "Path",
    fill: "#FFD15C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.360577,106.5 C301.586538,105.360925 299.8125,105.360925 298.038462,106.5 L298.038462,101.175 L303.360577,101.175 L303.360577,106.5 Z",
    id: "Path",
    fill: "#FFCF06",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.038462,102.637309 C299.713061,103.508919 301.692989,103.500571 303.360577,102.614868",
    id: "Path",
    stroke: "#2F2E41",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.4,
    cx: 311.34375,
    cy: 51.475,
    rx: 6.20913462,
    ry: 7.1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFD15C",
    fillRule: "nonzero",
    points: "207.5625 97.625 207.5625 127.3946 199.520151 143.27211 199.520151 143.273829 199.265302 143.775 177.97394 142.399103 169.789227 141.869382 150.793269 140.641394 150.793269 105.031799 169.789227 105.556015 178.283978 105.79095 199.775001 106.384994"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "207.5625 101.175 207.5625 128.364429 205.828705 132.129017 205.828705 132.130352 204.050867 135.989088 204.050867 135.990423 200.466346 143.775 200.867073 114.88089 200.948025 109.052389 204.356685 104.993339 204.356685 104.992003 205.842662 103.222554"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFD15C",
    fillRule: "nonzero",
    points: "209.336538 90.9445506 209.336538 101.623731 208.262915 103.371741 206.34484 106.495054 204.645915 109.261559 200.891342 115.375 200.801124 115.370407 150.793269 112.741681 150.793269 102.208756 150.919436 102.069919 156.889697 95.4647172 159.050772 93.0744517 162.959855 88.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "200.466346 102.358616 200.466346 113.6 149.019231 110.78956 149.019231 99.5481759 149.148795 99.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.15,
    points: "207.5625 90.525 207.5625 100.611679 200.466346 113.6 200.466346 103.651463"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero",
    points: "207.5625 94.9570838 207.557987 101.806156 207.556599 105.109639 207.542366 131.00137 207.542366 131.002719 205.55254 134.9 205.850389 107.750201 205.894824 103.594629 205.894824 103.593281 205.962517 97.4593959 157.889423 94.5814504 160.059763 92.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero",
    points: "182.725962 95.85 179.177414 102.884902 179.145597 106.470956 178.823035 142 170.307692 141.485894 170.307692 102.416532 174.850988 95.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.248551,95.8282622 C169.366747,96.4597784 167.344464,96.5313876 165.423388,96.0345316 C165.049301,95.961463 164.69855,95.797398 164.401585,95.5565803 C164.082113,95.2005631 163.863766,94.764213 163.769555,94.2935133 C163.42982,93.3208931 163.24158,92.3010387 163.211538,91.2702613 C163.234894,90.2410642 163.62529,89.1669519 164.457725,88.5713191 C164.627071,88.4681149 164.785676,88.3479621 164.931138,88.2126812 C165.10483,87.9916577 165.229709,87.7357586 165.297417,87.4621136 C165.86687,85.7487364 166.970789,83.9394785 168.741594,83.6652099 C170.375381,83.4121631 171.862281,84.5630843 173.121099,85.6436261 L175.883906,88.0151673 C176.511375,86.3139379 178.110752,85.1764742 179.910127,85.1517516 C181.709502,85.1270291 183.339,86.2201296 184.012176,87.9034887 C185.686312,86.0011744 187.796365,84.5408017 190.158374,83.6496897 C190.681788,83.4529478 191.296528,83.292765 191.773643,83.5857331 C192.06845,83.8051486 192.292168,84.1077783 192.416532,84.4553873 C193.168562,86.115861 193.576131,87.9138738 193.614209,89.739003 C194.011561,89.6018291 194.450508,89.754565 194.679496,90.1096806 C194.893496,90.4613987 195.015495,90.8621475 195.034067,91.2743952 C195.10776,91.9113233 195.144231,92.5520462 195.144231,93.1932969 C195.143893,93.8695273 195.081748,94.5999667 194.644802,95.1128419 C194.08019,95.7755632 193.105363,95.845648 192.239315,95.866433 C192.656347,96.2397718 192.45273,96.9916497 191.991468,97.3076543 C191.530207,97.6236589 190.933585,97.6294688 190.376018,97.6239941 C188.226488,97.6028874 185.939957,97.54125 184.151933,96.3376399 C183.445942,95.862404 182.854638,95.2295043 182.146798,94.7570278 C180.411892,93.5990135 178.233683,93.5436668 176.225484,93.63949 C174.413006,93.7259753 172.97432,95.2452988 171.248551,95.8282622 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.206593,95.85 C172.206593,95.85 153.415309,98.5885702 150.793269,110.455708 L154.726329,109.847135 L157.494038,115.019991 C157.494038,115.019991 160.407415,103.457138 169.00188,100.718568 C177.596346,97.9799978 180.655389,97.5235805 180.655389,97.5235805 C180.655389,97.5235805 186.627826,99.0450206 192.017561,117.15 L195.076597,112.73786 L200.466346,113.955001 C200.466346,113.955001 196.533287,99.8057186 185.899458,95.85 L172.206593,95.85 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork5);
export default __webpack_public_path__ + "static/media/work-5.85675e6d39ffbf6c3c1e1227a5980576.svg";
export { ForwardRef as ReactComponent };